import { useSettings } from 'context/SettingsContext';
import CountBadge from '../../CounBadge';
import { formatPrice } from 'utils/helpers/functions/formatPrice';
import { withLocalCurrency, withPrimaryCurrency } from 'utils/helpers/currency/currencyHelpers';
import type { StockLotRow } from './types';

interface StockLotsTableRowProps {
    row: StockLotRow;
    showPrices: boolean;
    showRate: boolean;
    isUahMode: boolean;
    plainStock?: boolean;
}

const StockLotsTableRow = ({ row, showPrices, showRate, isUahMode, plainStock = false }: StockLotsTableRowProps) => {
    const { localSettings } = useSettings();
    const currentRate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const price = formatPrice(row.operPrice);
    const priceRate = formatPrice(row.operPriceRate);
    const rate = formatPrice(Number(row.operPriceRate || 0) / (Number(row.operPrice) || 1));

    return (
        <tr>
            {showPrices && (
                <td className="price">
                    <div className="w-100 text-end lh-1">
                        <div className="fs-12 fw-semibold">{withPrimaryCurrency(price, currentRate)}</div>
                        {!isUahMode && (
                            <div className="text-muted fs-10 mt-1">{withLocalCurrency(priceRate)}</div>
                        )}
                    </div>
                </td>
            )}
            {showRate && <td className="rate text-end fs-12">{rate}</td>}
            <td className="count">
                {plainStock ? (
                    <span className="fs-12">{row.stock}</span>
                ) : (
                    <CountBadge fs={12} count={row.stock} />
                )}
            </td>
        </tr>
    );
};

export default StockLotsTableRow;
